import { InterfaceModes } from '@unifyapps/carbon/no-code/stores/InterfaceStore';
import type { InterfaceEntity, NavigationResolution } from '@unifyapps/defs/types/interface';
import type { ReactElement } from 'react';
import { Children, cloneElement, useMemo } from 'react';
import { useAppNavigationModel } from '../hooks/useAppNavigationModel';

export function DrawerNavController({
  unopenedNotificationsCount,
  interfaceRecord,
  children,
  resolution,
}: {
  unopenedNotificationsCount?: number;
  interfaceRecord?: InterfaceEntity;
  children: React.ReactNode;
  resolution: NavigationResolution;
}) {
  const {
    buildNavigation,
    app,
    navigationParams: {
      navigationProps: { position, theme },
    },
  } = useAppNavigationModel({
    interfaceRecord,
    resolution,
    unopenedNotificationsCount,
  });

  const navigation = useMemo(
    () =>
      buildNavigation({
        buildUserMenu: (item, { user }) => ({
          type: 'USER_MENU',
          id: item.id,
          user: { name: user.name, email: user.email },
        }),
        buildAction: (item) => {
          if (item.action !== 'showNotifications') return item;
          return {
            ...item,
            icon:
              unopenedNotificationsCount && unopenedNotificationsCount > 0
                ? 'BellNotification'
                : 'SvgNotification',
          };
        },
      }),
    [buildNavigation, unopenedNotificationsCount],
  );

  return Children.map(children, (child) => {
    return cloneElement(child as ReactElement<Record<string, unknown>>, {
      navigation,
      app,
      position,
      theme,
      mode: InterfaceModes.RUNNER,
    });
  });
}
